export default function compact(value) {
  return value?.filter(Boolean);
}
